import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import LiveCounter from "@/components/LiveCounter";
import HowItWorks from "@/components/HowItWorks";
import Tiers from "@/components/Tiers";
import SlabShowcase from "@/components/SlabShowcase";
import Submission from "@/components/Submission";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main className="relative min-h-screen bg-ink-900 text-white" data-testid="landing-page">
      <Header />
      <Hero />
      <LiveCounter />
      <HowItWorks />
      <Tiers />
      <SlabShowcase />
      <Submission />
      <FAQ />
      <Footer />
    </main>
  );
}
